import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {RequestMapperService} from "../../request-mapper.service";
import {Router} from "@angular/router";
import {ProductInFinishProduct} from "../../product-details/interface/product-in-finish-product";
import {
	ProductDetailsTransmissionService
} from "../../raintree/transmission/product-details/product-details-transmission.service";
import {BrowserAPIService, SeoData, SeoService} from "@bloomscorp/ngbase";
import {LightGalleryItem} from "../interface/light-gallery-item";
import {ImageService} from "../../product-details/service/image.service";
import {ProductLightGalleryComponent} from "../product-light-gallery/product-light-gallery.component";
import {ProductShareIconComponent} from "../product-share-icon/product-share-icon.component";
import {ProductWishlistIconComponent} from "../product-wishlist-icon/product-wishlist-icon.component";
import {ProductSkuComponent} from "../product-sku/product-sku.component";
import {IReviewStats} from "../../review/interface/review-stats";
import {ReviewTransmissionService} from "../../raintree/transmission/review-transmission.service";
import {ProductPriceComponent} from "../product-price/product-price.component";
import {ProductVariantComponent} from "../product-variant/product-variant.component";
import {ProductBulkDiscountComponent} from "../product-bulk-discount/product-bulk-discount.component";
import {ProductCompositionComponent} from "../product-composition/product-composition.component";
import {ProductQuantityInputComponent} from "../product-quantity-input/product-quantity-input.component";
import {
	ProductCustomFabricProfileComponent
} from "../product-custom-fabric-profile/product-custom-fabric-profile.component";
import {ProductCartButtonsComponent} from "../product-cart-buttons/product-cart-buttons.component";
import {ProductSwatchButtonComponent} from "../product-swatch-button/product-swatch-button.component";
import {PipeModule} from "../../pipe/pipe.module";
import {ObserveBreakpointService} from "../../observe-breakpoint.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {ProductTabsComponent} from "../product-tabs/product-tabs.component";
import {ProductDescriptionComponent} from "../product-description/product-description.component";
import {ProductSizeProfileComponent} from "../product-size-profile/product-size-profile.component";
import {ProductFinishProfileComponent} from "../product-finish-profile/product-finish-profile.component";
import {ProductInformationService} from "../product-information-service";
import {FabricProfileItemList} from "../../product-details/interface/fabric-profile-item-list";
import {FinishProfileItem} from "../../product-details/interface/finish-profile-item-list";
import {SizeProfileOptionItem} from "../../product-details/interface/size-profile-option-item";
import {VolumeDiscountProfileItem} from "../../product-details/interface/volume-discount-profile-item";
import {LoaderModule} from "../../loader/loader.module";
import {ProductReviewSectionComponent} from "../product-review-section/product-review-section.component";
import {ProductContentCardsComponent} from "../product-content-cards/product-content-cards.component";
import {TwitterCardType} from "../../seo/model/twitter-card-type";
import {AddStructuredDataService} from "../../add-structured-data.service";

@UntilDestroy()
@Component({
  selector: 'fb-product-detail',
  standalone: true,
	imports: [CommonModule, ProductLightGalleryComponent, ProductShareIconComponent, ProductWishlistIconComponent, ProductSkuComponent, ProductPriceComponent, ProductVariantComponent, ProductBulkDiscountComponent, ProductCompositionComponent, ProductQuantityInputComponent, ProductCustomFabricProfileComponent, ProductCartButtonsComponent, ProductSwatchButtonComponent, PipeModule, ProductTabsComponent, ProductDescriptionComponent, ProductSizeProfileComponent, ProductFinishProfileComponent, LoaderModule, ProductReviewSectionComponent, ProductContentCardsComponent],
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {

	public product: Product = {} as Product;
	public productResponse: ProductInFinishProduct = {} as ProductInFinishProduct;
	public productGallery: LightGalleryItem[] = [];
	protected reviewCount: number = 0;
	protected rating: number = 0;
	public loading: boolean = false;
	public urlCategory: string = '';
	public fromDays: number = 0;
	public toDays: number = 0;
	public isMd: boolean = false;
	public activeTab: string = 'customization';
	public quantityFromUser: number = 0;
	public quantityInStock: number = 0;
	public minimumOrderQuantity: number = 1;
	public calculatedPrice: number = 0;
	public calculatedDiscountPrice: number = 0;
	public stockMessage: string = '';
	public selectedFabric: FabricProfileItemList | undefined;
	public selectedSize: SizeProfileOptionItem = {} as SizeProfileOptionItem;
	public selectedFinishes: FinishProfileItem[] = [];
	public customSize: any;
	public customizationSelected: boolean = false;
	public orderTypeInStock: boolean = true;

	@ViewChild('customization') customization: ElementRef | undefined;
	@ViewChild('reviewSection') reviewComponent: ElementRef | undefined;

	constructor(
		private _router: Router,
		private _productAPI: ProductDetailsTransmissionService,
		private _reviewAPI: ReviewTransmissionService,
		private _browser: BrowserAPIService,
		private _videoUrlService: ImageService,
		private _breakpointService: ObserveBreakpointService,
		public productService: ProductInformationService,
		private _seo: SeoService,
		private _structured: AddStructuredDataService,
	) {
	}

	private _prepareSlug(): void {

		const url: string = this._router.url;
		const urlParts: string[] = url.split('/');
		const category: string = urlParts[3];
		this.urlCategory = category;
		const slug: string = urlParts[4];
		//TODO: change this to 2 and 3

		switch (category) {
			case 'fabric-product':
				this.getProductDetailsFabric(RequestMapperService.GET_PRODUCT_DETAILS_FABRIC_V2 + slug);
				// this._cartCalculation.productGroup = 'fabric';
				// this._priceCalculation.isThisProductFabric = true;
				// this.isThisProductFabric = true;
				// this.isCusomizationOpen = false;
				break;
			case 'finished-product':
				this.getProductDetailsFinish(RequestMapperService.GET_PRODUCT_DETAILS_FINISH + slug);
				// this._cartCalculation.productGroup = 'finished';
				// this._priceCalculation.isThisProductFabric = false;
				// this.isThisProductFabric = false;
				// this.isCusomizationOpen = true;
				break;
			default:
				break;
		}
	}

	private _resolveReviewStats(): void {
		this._reviewAPI.getReviewStats(
			() => {
			},
			() => {
			},
			(response: IReviewStats) => {
				this.reviewCount = response.count;
				this.rating = response.rating;
			},
			(error: string) => {
			},
			() => {
			}
		);
	}

	private _prepareProductGallery(product: Product): void {
		this.productGallery.push(
				{
				src: product.heroImage,
				thumb: product.heroImage,
				subHtml: `<h4>${product.heroImageAlt? product.heroImageAlt: product.name}</h4>`,
				type: 'image',
				alt: product.heroImageAlt? product.heroImage: product.name
				}
		)

		if (product.productVideo) {
			this.productGallery.push(
				{
					src: this._videoUrlService.getLightURL(product.productVideo, true),
					poster: '',
					type: 'youtube',
					height: '80vh',
					autoplay: true,
					alt: '',
					subHtml: ''
				}
			)
		}

		if(product.hoverImage) {
			this.productGallery.push(
				{
					src: product.hoverImage,
					thumb: product.hoverImage,
					subHtml: `<h4>${product.hoverImageAlt? product.hoverImageAlt: product.name}</h4>`,
					type: 'image',
					alt: product.hoverImageAlt? product.hoverImageAlt: product.name
				}
			)
		}

		if (product.imageGallerySEOList && product.imageGallerySEOList.length > 0) {
			this.product.imageGallerySEOList.filter(item => !item.deleted).forEach(item => {
				this.productGallery.push(
					{
						src: item.image,
						thumb: item.image,
						type: 'image',
						alt: item.altText,
						subHtml: ''
					}
				)
			})
		}
	}

	private _initSEO(): void {
		const productDescription: string = this.product.metaDescription?  this.product.metaDescription : this._structured.removeHtmlTags(this.product.productOverview);
		const productName: string = this.product.metaTitle? this.product.metaTitle : this.product.name;

		const seoData: SeoData = {
			title: productName,
			tags: {
				description: {
					charset: 'utf-8',
					name: 'description',
					content: productDescription
				}
			},
			facebook: {
				title: productName,
				type: 'website',
				description: productDescription,
				image: {
					url: this.product.heroImage,
					type: 'image/jpeg',
					width: '600',
					height: '600',
					alt: productName
				},
				url: `https://anuprerna.com${this._router.url}`
			},
			twitter: {
				title: productName,
				description: productDescription,
				cardType: TwitterCardType.SUMMARY_LARGE,
				image: {
					url: this.product.heroImage,
					alt: productName
				}
			}
		};

		this._seo.set(seoData);
		this._structured.mapToProductStructure(this.product);
		this._structured.mapToProductMerchantListingStructure(this.product);
	}

	ngOnInit() {
		this._prepareSlug();
		this._resolveReviewStats();
		this._breakpointService.observe('md')
			.pipe(untilDestroyed(this))
			.subscribe((isMd) => {
				this.isMd = isMd;
			});
	}

	protected showReviews(): void {
		this.reviewComponent?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center'});
	}


	public getProductDetailsFabric(url: string): void {
		this._productAPI.getProductDetailsFabric(
			url,
			(): void => {
				this.loading = true;
			},
			(): void => {
			},
			(response: ProductInFinishProduct): void => {
				this.setProductData(response);
				// this._cartCalculation.fabricProductId = response.id;
				// this.isStoryListVisible = true;
				//
				// this._bloomsight.trackDataEvent(
				// 	'65b89f9fadae2d98edc82a62',
				// 	{sku: response.product.sku},
				// 	''
				// );

			},
			(error: string): void => {
				if (this._browser.isBrowser()) {
					this._router.navigate(['/404']).then((): void => {
					});
				}
			},
			(): void => {
			},
		)
	}

	public getProductDetailsFinish(url: string): void {
		this._productAPI.getProductDetailsFinish(
			url,
			(): void => {
				this.loading = true;
			},
			(response: ProductInFinishProduct): void => {
			},
			(response: ProductInFinishProduct): void => {
				this.setProductData(response);
				// this._cartCalculation.finishedProductId = response.id;
				// this.isStoryListVisible = true;
				//
				// this._bloomsight.trackDataEvent(
				// 	'65b89f9fadae2d98edc82a62',
				// 	{sku: response.product.sku},
				// 	''
				// );

			},
			(error: string): void => {
				if (this._browser.isBrowser()) {
					this._router.navigate(['/404']).then((): void => {
					});
				}
			},
			(): void => {
				// this.isLoading = false;
			},
		)
	}


	public setProductData(data: ProductInFinishProduct): void {
		this.productResponse = data;
		this.product = data.product;
		if(this.product.fabricProfileEnabled && this.product.fabricProfile &&  this.product.fabricProfile.fabricProfileItemList) {
			this.product.fabricProfile.fabricProfileItemList = this.product.fabricProfile.fabricProfileItemList.filter(fabricItem => fabricItem.fabricPreview.totalQuantity);
		}
		this._prepareProductGallery(this.product);
		this.activeTab = this.product.madeToOrderProfileEnabled ? 'customization' : 'description';
		if (this.product.subCategory.madeToOrderProfile) {
			this.fromDays = new Date().setDate((new Date().getDate() + this.product.subCategory.madeToOrderProfile.deliveryFromDays));
			this.toDays = new Date().setDate(new Date().getDate() + this.product.subCategory.madeToOrderProfile.deliveryToDays);
		}
		else if (this.product.madeToOrderProfileEnabled && this.product.madeToOrderProfile) {
			this.fromDays = new Date().setDate((new Date().getDate() + this.product.madeToOrderProfile.deliveryFromDays));
			this.toDays = new Date().setDate(new Date().getDate() + this.product.madeToOrderProfile.deliveryToDays);
		}
		const selectedFabricPrice: number = ( this.product.madeToOrderFabric)? this.product.madeToOrderFabric.price : 0;
		this.calculatePrice(selectedFabricPrice, 0, 0);
		this.stockMessage = this.productService.getStockMessage();
		this.loading = false;
		// this.copyQuantity = this.productData.totalQuantity;
		// this.calculationDefaultValue();
		// this.calculationPrice(this.productData);
		// this.calculateDefaultCartItem(this.productData);
		this._initSEO();
		//
		// // this._gtag.sendEventData({
		// // 	action: 'view_product',
		// // 	event: 'view_product',
		// // 	send_to: 'G-YY5WPYVGE4',
		// // 	ecommerce: {
		// // 		items: [{
		// // 			item_name: this.productData.name,
		// // 			item_id: this.productData.sku,
		// // 			price: this._priceCalculation.storediscountedPrice,
		// // 			item_category: this.productData.category.name,
		// // 			quantity: 1
		// // 		}]
		// // 	}
		// // });
	}

	public reCalculatePrice(): void {
		let selectedFabricPrice: number = 0;
		let customSizePrice: number = 0;
		let finishPrice: number = 0;
		if(this.selectedFabric) {
			selectedFabricPrice = this.selectedFabric.fabricPreview.price;
		}
		else {
			selectedFabricPrice =  ( this.product.madeToOrderFabric)? this.product.madeToOrderFabric.price : this.product.price;
		}

		if(this.customSize && Object.keys(this.customSize).length > 0 && this.product.customSizeProfileEnabled && this.product.customSizeProfile) {
			customSizePrice = this.product.customSizeProfile.price;
		}
		if(this.selectedFinishes.length > 0) {
			this.selectedFinishes.forEach(item => finishPrice += item.price);
		}
		if(this.selectedFabric || this.customSize || this.selectedFinishes.length > 0) {
			this.customizationSelected = true;
			this.setOrderTypeToMTOAfterCustomization();
		}
		else {
			this.customizationSelected = false;
			if(!this.product.fabricProfileEnabled) {
				this.setOrderTypeToInSTock();
			}
		}
		this.calculatePrice(selectedFabricPrice, finishPrice, customSizePrice, this.customizationSelected);
	}

	public calculatePrice(
		selectedFabricPrice: number,
		selectedFinishPrice: number,
		customSizePrice: number,
		customizationSelected: boolean = false
	): void {
		if(this.product.productGroup !== 'finished') {
			this.quantityInStock = this.productService.calculateFabricProductQuantity(
				this.product,
				this.selectedFabric,
				customizationSelected
			);
			this.calculatedPrice = this.productService.calculateFabricProductPrice(
				this.product,
				selectedFabricPrice,
				selectedFinishPrice,
				customSizePrice
			);
		}
		else {
			this.quantityInStock = this.productService.calculateFinishProductQuantity(
				this.product,
				this.selectedFabric,
				this.selectedSize,
				!!customSizePrice,
				customizationSelected
			);
			this.calculatedPrice = this.productService.calculateFinishProductPrice(
				this.product,
				selectedFabricPrice,
				selectedFinishPrice,
				customSizePrice
			);
		}
		this.stockMessage = this.productService.getStockMessage();
		this.orderTypeInStock = this.productService.getOrderTypeInStock();
	}

	public showCustomization(): void {
		this.customization?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center'});
	}

	public onCustomSizeSelected($event: any): void {
		this.customSize = $event;
		this.reCalculatePrice();
	}

	public fabricSelected($event: FabricProfileItemList | undefined): void {
		this.selectedFabric = $event;
		this.reCalculatePrice();
	}

	public finishSelectionChange($event: any): void {
		this.selectedFinishes = $event;
		this.reCalculatePrice();
	}

	public onSizeSelected($event: any): void {
		this.selectedSize = $event;
		this.reCalculatePrice();
		this.calculateVDPrice();
	}

	public setOrderTypeToMTOAfterCustomization(): void {
		this.productService.setOrderTypeInStock(false);
		this.productService.setStockMessage('for made to order');
		this.minimumOrderQuantity = this.product.madeToOrderProfileEnabled && this.product.madeToOrderProfile ? this.product.madeToOrderProfile.minimumOrderQuantity : 1;
	}

	public setOrderTypeToInSTock(): void {
		this.productService.setOrderTypeInStock(true);
		this.stockMessage = 'in stock!';
		this.minimumOrderQuantity = 1;
	}

	public onQuantityChange($event: number): void {
		this.quantityFromUser = $event;
		this.calculateVDPrice();
	}

	public calculateVDPrice(): void {
		if (this.product.volumeDiscountProfileEnabled && this.product.volumeDiscountProfile) {
			const vDList: VolumeDiscountProfileItem[] = this.product.volumeDiscountProfile.volumeDiscountProfileItemList.sort((a, b) => b.minimumOrderQuantity - a.minimumOrderQuantity);
			for (const item of vDList) {
				if (item.minimumOrderQuantity <= this.quantityFromUser) {
					this.calculatedDiscountPrice = this.productService.calculateVDProductPrice(
						this.product,
						this.selectedFabric,
						item,
						item.minimumOrderQuantity
					);
					break;
				}
			}
		}
	}
}
